/* eslint-disable */

/* The behaviour script expects these functions to be defined.
   When they return true the zooming lib is initiated. We do
   this at another place in the new react code so we have to
   return false from the functions to skip the initialisation. */
window.topmeteo_hastouch = window.topmeteo_ismobile = () => false;

import 'bootstrap-less/js/collapse';
import 'bootstrap-less/js/carousel';
import 'bootstrap-less/js/transition';

import './behavior';
